
import api from "../api/apiClient";

type HttpMethod = "POST" | "PUT" | "PATCH" | "DELETE";

export async function apiRequest<T>(
  method: HttpMethod,
  url: string,
  data: any = undefined,
  headers: Record<string, string> = {}
): Promise<T> {
  try {
    let response;

    if (method === "DELETE") {
      response = await api.delete<T>(url, {
        headers,
        data,
      });
    } else {
      const axiosMethod = method.toLowerCase() as "post" | "put" | "patch";
      response = await api[axiosMethod]<T>(url, data, { headers });
    }

    return response.data;
  } catch (error: any) {
    console.error(`[${method}] ${url} failed:`, error.message || error);
    throw error;
  }
}
export const apiPost = <T>(
  url: string,
  data?: any,
  headers?: Record<string, string>
) => apiRequest<T>("POST", url, data, headers);

export const apiPut = <T>(
  url: string,
  data?: any,
  headers?: Record<string, string>
) => apiRequest<T>("PUT", url, data, headers);

export const apiPatch = <T>(
  url: string,
  data?: any,
  headers?: Record<string, string>
) => apiRequest<T>("PATCH", url, data, headers);

export const apiDelete = <T>(url: string, headers?: Record<string, string>) =>
  apiRequest<T>("DELETE", url, undefined, headers);
